import { render, staticRenderFns } from "./ActivitiesSidebar.vue?vue&type=template&id=70ce794e&scoped=true&"
import script from "./ActivitiesSidebar.vue?vue&type=script&lang=js&"
export * from "./ActivitiesSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesSidebar.vue?vue&type=style&index=0&id=70ce794e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ce794e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ce794e')) {
      api.createRecord('70ce794e', component.options)
    } else {
      api.reload('70ce794e', component.options)
    }
    module.hot.accept("./ActivitiesSidebar.vue?vue&type=template&id=70ce794e&scoped=true&", function () {
      api.rerender('70ce794e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/activities/ActivitiesSidebar.vue"
export default component.exports